<template>
  <div>
    <v-btn depressed color="primary" @click="openModal" class="mb-4">Upload</v-btn>
    <v-dialog v-model="dialog" persistent max-width="500" overlay-color="#fff" :overlay-opacity="0.7">
      <v-card>
        <v-card-title class="headline">Upload invoice filer</v-card-title>
        <v-card-text class="py-4">
          <div class="text-body-2 mb-2 grey--text text--darken-1">
            Understøttede typer: Fakturaer, Overslag, Kvittering, Rykker, Diverse.
          </div>
          <div v-for="(item, index) in files" :key="item.id" class="d-flex align-center">
            <div class="grow">
              <v-file-input :value="item.file" show-size label="File" disabled :clearable="false"/>
            </div>
            <div>
              <v-btn icon color="primary" @click="removeFile(index)">
                <v-icon>icon-close</v-icon>
              </v-btn>
            </div>
          </div>
          <v-row align="center" class="my-4">
            <v-col class="py-0">
              <v-btn block depressed color="primary" @click="fileTrigger">
                Gennemse...
              </v-btn>
              <input ref="fileUploader" class="d-none" accept=".pdf" type="file" multiple @input="addFile($event)"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed :color="uploadButtonColor" :loading="uploadLoading" :disabled="uploadLoading" @click="uploadFiles">Upload</v-btn>
          <v-btn color="black darken-1" text @click="closeModal">Annuller</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import api from '../../api/api';
  import methods from '@/utils/methods';

  export default {
    name: 'OverviewInvoicesUpload',

    props: {
      visitItem: {
        type: Object,
      },
    },

    data: function () {
      return {
        dialog: false,
        uploadLoading: false,
        uploadButtonColor: 'primary',
        files: [],
      };
    },

    methods: {
      openModal: function () {
        this.dialog = true;
        this.uploadButtonColor = 'primary';
      },
      closeModal: function () {
        this.files = [];
        this.dialog = false;
      },
      fileTrigger: function () {
        this.$refs.fileUploader.click();
      },
      addFile: function (data) {
        if (data.target.files.length > 0) {
          Object.keys(data.target.files).forEach(key => {
            let fileItem = data.target.files[key];
            let fileType = fileItem.name.split('.').pop().toLowerCase();
            let newId = crypto.randomUUID();
            switch (fileType) {
              case 'pdf':
                this.files.push({
                  id: newId,
                  file: fileItem,
                });
                break;
              default:
                methods.showGlobalSnackbar('error', 'Denne filtype er ikke godkendt i dette felt.');
            }
          });
          data.target.value = '';
        }
      },
      removeFile: function (index) {
        this.$delete(this.files, index);
      },
      uploadFiles: async function () {
        try {
          this.uploadButtonColor = 'primary';
          let newData = new FormData();
          if (this.files.length > 0) {
            this.files.forEach((item) => {
              newData.append(`Invoices`, item.file);
            });
          }
          this.uploadLoading = true;
          await api.uploadInvoices(newData, this.visitItem.id);
          let invoicesData = await api.getInvoices(this.visitItem.id);
          this.uploadLoading = false;
          this.files = [];
          this.dialog = false;
          this.$emit('updateInvoices', invoicesData);
        } catch (e) {
          this.uploadLoading = false;
          this.uploadButtonColor = 'error';
          methods.showGlobalSnackbar('error', methods.getErrors(e.response));
        }
      },
    },
  };
</script>
